(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-hero2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hero-info-popup')) {
  customElements.define('hero-info-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.trigger = this.querySelector('[data-hero-help-trigger]');
      this.dialog = this.querySelector('[data-hero-help-dialog]');
      this.closeButton = this.querySelector('[data-hero-help-close]');
      if (!this.trigger || !this.dialog || !this.closeButton) return;

      this.events = new AbortController();
      const signal = this.events.signal;
      this.trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.dialog.open) {
          this.dialog.close();
          return;
        }
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        this.closeButton.focus({ preventScroll: true });
      }, { signal });

      this.closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.dialog.close();
      }, { signal });

      this.dialog.addEventListener('click', (event) => {
        event.stopPropagation();
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right ||
            event.clientY < rect.top || event.clientY > rect.bottom) {
          this.dialog.close();
        }
      }, { signal });

      this.dialog.addEventListener('close', () => {
        if (this.dialog.open) return;
        this.trigger.setAttribute('aria-expanded', 'false');
        if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
      }, { signal });

      document.addEventListener('shopify:block:deselect', (event) => {
        if (event.detail && event.detail.blockId === this.dataset.blockId && this.dialog.open) {
          this.dialog.close();
        }
      }, { signal });
    }

    disconnectedCallback() {
      if (this.events) this.events.abort();
      if (this.dialog && this.dialog.open) this.dialog.close();
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
      this.events = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-social-posts"] && !Shopify.designMode) return;
  try {
    
(() => {
  const elementName = 'social-post-gallery-v4';
  if (customElements.get(elementName)) {
    document.querySelectorAll(elementName).forEach(section => section.connectedCallback());
    return;
  }
  const sdkPromises = new Map();
  function loadSDK(src, isReady) {
    if (isReady()) return Promise.resolve();
    if (sdkPromises.has(src)) return sdkPromises.get(src);
    const promise = new Promise((resolve, reject) => {
      let script = Array.from(document.scripts).find(item => item.src === src);
      const owned = !script;
      if (!script) { script = document.createElement('script'); script.src = src; script.async = true; }
      let timer;
      let poll;
      const cleanup = () => { clearTimeout(timer); clearInterval(poll); script.removeEventListener('error', fail); };
      const fail = () => { cleanup(); if (owned) script.remove(); reject(new Error('Social embed could not load')); };
      const check = () => { if (isReady()) { cleanup(); resolve(); } };
      script.addEventListener('error', fail, { once: true });
      timer = setTimeout(fail, 12000);
      poll = setInterval(check, 100);
      if (owned) document.head.append(script);
      check();
    });
    sdkPromises.set(src, promise);
    promise.catch(() => { if (sdkPromises.get(src) === promise) sdkPromises.delete(src); });
    return promise;
  }

  class SocialPostGallery extends HTMLElement {
    static parsePostURL(raw) {
      let url;
      try { url = new URL(raw); } catch (_) { return null; }
      if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password || url.port) return null;
      const host = url.hostname.toLowerCase();
      const result = { platform: 'other', canonical: url.href, supported: false };
      let match;
      if (['instagram.com', 'www.instagram.com'].includes(host)) {
        result.platform = 'instagram';
        match = url.pathname.match(new RegExp('^/(p|reel|tv)/([A-Za-z0-9_-]+)/?$'));
        if (match) Object.assign(result, { supported: true, id: match[2], canonical: `https://www.instagram.com/${match[1]}/${match[2]}/` });
      } else if (['tiktok.com', 'www.tiktok.com', 'm.tiktok.com'].includes(host)) {
        result.platform = 'tiktok';
        match = url.pathname.match(new RegExp('^/@([A-Za-z0-9_.]+)/(video|photo)/([0-9]{10,25})/?$'));
        if (match) Object.assign(result, { supported: true, id: match[3], canonical: `https://www.tiktok.com/@${match[1]}/${match[2]}/${match[3]}`, embedURL: `https://www.tiktok.com/player/v1/${match[3]}?autoplay=0` });
      } else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtu.be', 'www.youtu.be', 'www.youtube-nocookie.com', 'youtube-nocookie.com'].includes(host)) {
        result.platform = 'youtube';
        let id = '';
        if (host === 'youtu.be' || host === 'www.youtu.be') {
          match = url.pathname.match(new RegExp('^/([A-Za-z0-9_-]{11})/?$'));
          if (match) id = match[1];
        } else if (url.pathname === '/watch') {
          id = url.searchParams.get('v') || '';
        } else {
          match = url.pathname.match(new RegExp('^/(?:shorts|embed|live)/([A-Za-z0-9_-]{11})/?$'));
          if (match) id = match[1];
        }
        if (/^[A-Za-z0-9_-]{11}$/.test(id)) Object.assign(result, { supported: true, id, canonical: `https://www.youtube.com/watch?v=${id}`, embedURL: `https://www.youtube-nocookie.com/embed/${id}` });
      } else if (['x.com', 'www.x.com', 'twitter.com', 'www.twitter.com', 'mobile.twitter.com'].includes(host)) {
        result.platform = 'x';
        match = url.pathname.match(new RegExp('^/(?:[A-Za-z0-9_]+/status|i/web/status)/([0-9]{5,25})(?:/(?:photo|video)/[0-9]+)?/?$'));
        if (match) Object.assign(result, { supported: true, id: match[1], canonical: `https://twitter.com/i/web/status/${match[1]}` });
      }
      return result;
    }

    connectedCallback() {
      if (this.events) return;
      this.dialog = this.querySelector('[data-social-dialog]');
      this.host = this.querySelector('[data-social-host]');
      this.status = this.querySelector('[data-social-status]');
      this.titleElement = this.querySelector('[data-social-title]');
      this.original = this.querySelector('[data-social-original]');
      this.closeButton = this.querySelector('[data-social-close]');
      if (!this.dialog || !this.host || !this.status || !this.titleElement || !this.original || !this.closeButton) {
        if (!this.contentObserver) {
          this.contentObserver = new MutationObserver(() => this.connectedCallback());
          this.contentObserver.observe(this, { childList: true, subtree: true });
        }
        return;
      }
      this.contentObserver?.disconnect();
      this.contentObserver = null;
      this.generation = this.generation || 0;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.querySelectorAll('[data-social-trigger]').forEach(card => {
        const post = SocialPostGallery.parsePostURL(card.dataset.socialUrl);
        const badge = card.querySelector('[data-social-platform]');
        if (badge) badge.textContent = ({ instagram: 'IG', tiktok: 'TikTok', youtube: 'YouTube', x: 'X' })[post?.platform] || '';
      });
      this.addEventListener('click', event => {
        const trigger = event.target.closest?.('[data-social-trigger]');
        if (!trigger || !this.contains(trigger) || (typeof event.button === 'number' && event.button !== 0)) return;
        const post = SocialPostGallery.parsePostURL(trigger.dataset.socialUrl);
        event.preventDefault();
        event.stopPropagation();
        this.openPost(trigger, post);
      }, { ...options, capture: true });
      this.closeButton.addEventListener('click', () => this.closePost(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closePost();
      }, options);
      this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.clearPost(true); }, options);
      document.addEventListener('shopify:block:deselect', event => {
        if (event.detail?.blockId === this.activeTrigger?.dataset.blockId && this.dialog.open) this.closePost();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        if (this.dataset.designMode !== 'true' || this.dataset.editorPreview !== 'true' || event.detail?.load) return;
        const trigger = Array.from(this.querySelectorAll('[data-social-trigger]')).find(card => card.dataset.blockId === event.detail?.blockId);
        if (!trigger || (this.dialog.open && this.activeTrigger === trigger)) return;
        this.openPost(trigger, SocialPostGallery.parsePostURL(trigger.dataset.socialUrl));
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.fallbackBackdrop && this.dialog.open) { event.preventDefault(); this.closePost(); }
      }, options);
      this.dataset.socialReady = 'true';
    }

    disconnectedCallback() {
      this.contentObserver?.disconnect();
      this.contentObserver = null;
      this.events?.abort();
      this.events = null;
      if (this.dialog?.open) this.closePost();
      this.clearPost(false);
      delete this.dataset.socialReady;
    }

    closePost() {
      if (typeof this.dialog.close === 'function') this.dialog.close();
      else this.dialog.removeAttribute('open');
      this.clearPost(true);
    }

    clearPost(restoreFocus) {
      this.generation = (this.generation || 0) + 1;
      this.embedEvents?.abort();
      this.observer?.disconnect();
      clearTimeout(this.embedTimer);
      this.fallbackBackdrop?.remove();
      this.fallbackBackdrop = null;
      this.host?.replaceChildren();
      if (this.activeTrigger) {
        this.activeTrigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus && this.activeTrigger.isConnected) this.activeTrigger.focus({ preventScroll: true });
      }
      this.activeTrigger = null;
    }

    setStatus(message) {
      this.status.textContent = message;
      this.status.hidden = !message;
    }

    async openPost(trigger, post) {
      this.clearPost(false);
      this.activeTrigger = trigger;
      trigger.setAttribute('aria-expanded', 'true');
      this.titleElement.textContent = trigger.dataset.postTitle || this.dataset.postLabel || 'Social post';
      if (post) this.original.href = post.canonical;
      else this.original.removeAttribute('href');
      this.setStatus(this.dataset.loadingLabel || 'Loading post…');
      const slot = document.createElement('div');
      slot.className = 'social-posts__slot';
      this.host.append(slot);
      this.embedEvents = new AbortController();
      const signal = this.embedEvents.signal;
      const generation = this.generation;
      const isCurrent = () => this.isConnected && this.dialog.open && this.generation === generation;
      const loaded = () => {
        if (!isCurrent()) return;
        clearTimeout(this.embedTimer);
        this.setStatus('');
      };
      const fallback = unsupported => {
        if (!isCurrent()) return;
        clearTimeout(this.embedTimer);
        const instagramURLHint = this.dataset.instagramUrlLabel || 'This gallery needs a single Instagram post or reel link containing /p/ or /reel/. An account profile cannot be displayed as a post.';
        const inPlaceError = this.dataset.popupErrorLabel || 'This post cannot be displayed in this window. Please try again later.';
        const message = unsupported ? (post.platform === 'instagram' ? instagramURLHint : this.dataset.unsupportedLabel) : this.dataset.fallbackLabel;
        this.setStatus(this.dataset.showOriginal !== 'true' && !(unsupported && post.platform === 'instagram') ? inPlaceError : message);
        if (!slot.children.length) {
          const cover = trigger.querySelector('.social-posts__image');
          if (cover) {
            const image = document.createElement('img');
            image.src = cover.currentSrc || cover.src;
            image.alt = cover.alt || this.titleElement.textContent;
            image.className = 'social-posts__fallback-image';
            slot.append(image);
          }
        }
      };
      if (typeof this.dialog.showModal === 'function') {
        if (!this.dialog.open) this.dialog.showModal();
      } else {
          this.dialog.setAttribute('open', '');
          this.dialog.setAttribute('aria-modal', 'true');
          this.fallbackBackdrop = document.createElement('div');
          this.fallbackBackdrop.className = 'social-posts__fallback-backdrop';
          this.fallbackBackdrop.addEventListener('click', () => this.closePost(), { signal });
          document.body.append(this.fallbackBackdrop);
      }
      this.dialog.querySelector('.social-posts__modal-body').scrollTop = 0;
      this.closeButton.focus({ preventScroll: true });
      if (!post) {
        this.setStatus(this.dataset.missingUrlLabel || 'Please add a valid, complete post link for this image.');
        return;
      }
      if (!post.supported) { fallback(true); return; }
      this.embedTimer = setTimeout(() => fallback(false), 15000);
      try {
        if (post.platform === 'instagram') {
          await loadSDK('https://www.instagram.com/embed.js', () => typeof window.instgrm?.Embeds?.process === 'function');
          if (!isCurrent()) return;
          slot.replaceChildren();
          const block = document.createElement('blockquote');
          block.className = 'instagram-media';
          block.setAttribute('data-instgrm-permalink', post.canonical);
          block.setAttribute('data-instgrm-version', '14');
          block.setAttribute('data-instgrm-captioned', '');
          block.style.cssText = 'width:100%;max-width:540px;min-width:0;margin:0 auto;';
          const link = document.createElement('a');
          link.href = post.canonical;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          link.textContent = this.titleElement.textContent;
          block.append(link);
          slot.append(block);
          const observed = new WeakSet();
          this.observer = new MutationObserver(() => {
            slot.querySelectorAll('iframe').forEach(frame => {
              if (observed.has(frame)) return;
              observed.add(frame);
              frame.title = this.titleElement.textContent;
              frame.addEventListener('load', loaded, { once: true, signal });
            });
          });
          this.observer.observe(slot, { childList: true, subtree: true });
          window.instgrm.Embeds.process();
        } else if (post.platform === 'x') {
          await loadSDK('https://platform.twitter.com/widgets.js', () => typeof window.twttr?.widgets?.createTweet === 'function');
          if (!isCurrent()) return;
          slot.replaceChildren();
          const rendered = await window.twttr.widgets.createTweet(post.id, slot, { dnt: true, theme: 'light', align: 'center' });
          if (!isCurrent()) return;
          if (rendered) loaded(); else fallback(false);
        } else {
          const frame = document.createElement('iframe');
          frame.title = this.titleElement.textContent;
          frame.className = post.platform === 'youtube' ? 'social-posts__video-frame' : 'social-posts__tiktok-frame';
          frame.allow = 'fullscreen; encrypted-media; picture-in-picture';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          frame.addEventListener('load', loaded, { once: true, signal });
          frame.addEventListener('error', () => fallback(false), { once: true, signal });
          frame.src = post.embedURL;
          slot.replaceChildren(frame);
        }
      } catch (_) { fallback(false); }
    }
  }
  customElements.define(elementName, SocialPostGallery);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll(elementName).forEach(section => section.connectedCallback());
  });
})();


  } catch(e) { console.error(e); }
})();
})();
